<template>
  <!--begin::Footer-->
  <br /><br /><br />
  <div id="kt_app_footer" class="app-footer">
    <!--begin::Footer container-->
    <div
      class="app-container container-fluid d-flex flex-column flex-md-row flex-center flex-md-stack py-3"
    >
      <!--begin::Copyright-->
      <div class="text-dark order-2 order-md-1">
        <span class="text-muted fw-semibold me-1">{{ currentYear }}&copy;</span>
        <a
          href="https://academia.ly"
          target="_blank"
          class="text-gray-800 text-hover-primary"
          >Academia - أكاديميا
        </a>

        <a
          class="ml-3"
          href="https://t.me/aca_demia"
          target="_blank"
          style="
            border-radius: 10px;
            padding: 2px 10px;
            margin-right: 15px;
            background: aliceblue;
          "
        >
          0913103064 ( تليغرام) <i class="bi bi-telegram" style="color: #60c8ff"></i>
        </a>
      </div>
      <!--end::Copyright-->
      <!--begin::Menu-->
      <ul class="menu menu-gray-600 menu-hover-primary fw-semibold order-1">
        <li class="menu-item">
          <a href="https://academia.ly" target="_blank" class="menu-link px-2"
            >Academia Team</a
          >
        </li>
        <li class="menu-item" style="padding: 10px">
          <a href="privacy-policy" target="_blank" class="text-muted"
            ><i class="mdi mdi-account"></i> سياسة الخصوصية
          </a>
          |
          <a href="terms-of-service" target="_blank" class="text-muted"
            ><i class="mdi mdi-account"></i> سياسة الإستخدام
          </a>
        </li>
      </ul>
      <!--end::Menu-->
    </div>
    <!--end::Footer container-->
  </div>
  <div
    dir="rtl"
    class="modal fade forgetpassword-modal"
    id="loginModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">تسجيل الدخول</h5>
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">
            <i class="fa fa-close"></i> إغلاق
          </button>
        </div>
        <div class="modal-body">
          <div class="card text-center p-5 not-login">
            <span class="icon"><i class="bi bi-person-badge"></i></span>
            <h3 class="mb-4">يرجى تسجيل الدخول للإستمرار</h3>
            <span>
              <a href="login" class="btn btn-success">
                تسجيل الدخول <i class="fa fa-sign-in"></i>
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--end::Footer-->
  <!-- END: Footer-->
</template>

<script>
export default {
  name: "FooterComponent",
  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  },
};
</script>
